import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface DiscardEditsDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export default function DiscardEditsDialog({
  isOpen,
  setIsOpen,
}: DiscardEditsDialogProps) {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();
  const { search } = useLocation();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content className="lg:w-[448px]">
        <Title>You have unsaved changes</Title>
        <Description className="mb-8">
          Are you sure you want to leave?
        </Description>

        <div className="flex justify-between items-center gap-x-2.5">
          <Close asChild>
            <Button variant="secondary-black" className="lg:flex-1">
              Cancel
            </Button>
          </Close>

          <Button
            data-cy="delete-template-button"
            variant="outline-danger"
            className="lg:flex-1"
            onClick={() => navigate({ pathname: "..", search })}
          >
            Discard
          </Button>
        </div>
      </Content>
    </Component>
  );
}
